export default __webpack_public_path__ + "static/media/bulk-user-ids-samples.7b1ca32f.csv";